import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrdersState } from "@insite/client-framework/Store/Data/Orders/OrdersState";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export const initialState: OrdersState = {
    isLoading: {},
    idByOrderNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const OrderDetailsCustomReducer = {
    "Custom/OrderDetails/BeginLoadOrder": (draft: Draft<OrdersState>, action: { orderNumber: string }) => {
        draft.isLoading[action.orderNumber] = true;
    },

    "Custom/OrderDetails/CompleteLoadOrder": (draft: Draft<OrdersState>, action: { model: OrderModel }) => {
        delete draft.isLoading[action.model.webOrderNumber];
        delete draft.isLoading[action.model.erpOrderNumber];
        draft.byId[action.model.id] = action.model;
        storeIdByOrderNumber(draft, action.model);
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.model.webOrderNumber];
            delete draft.errorStatusCodeById[action.model.erpOrderNumber];
        }
    },

    "Custom/OrderDetails/FailedToLoadOrder": (draft: Draft<OrdersState>, action: { orderNumber: string; status: number }) => {
        delete draft.isLoading[action.orderNumber];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.orderNumber] = action.status;
        }
    },
};

function storeIdByOrderNumber(draft: Draft<OrdersState>, order: OrderModel) {
    if (order.erpOrderNumber) {
        draft.idByOrderNumber[order.erpOrderNumber] = order.id;
    }
    if (order.webOrderNumber) {
        draft.idByOrderNumber[order.webOrderNumber] = order.id;
    }
}

export default createTypedReducerWithImmer(initialState, OrderDetailsCustomReducer);